import { TsDOM as q} from '@/scripts/core/TsDOM'
import { DeferredMedia } from '@/scripts/theme/deferred-media'
import { DetailsDisclosure } from '@/scripts/theme/details-disclosure'
import { SliderComponent } from '@/scripts/theme/slider-component'
import { SlideshowComponent } from '@/scripts/theme/slideshow-component'
import { StickyHeader } from '@/scripts/theme/sticky-header'
import { UcoastVideo } from '@/scripts/core/ucoast-video';
import { ProductSlider } from '@/scripts/theme/product-slider'
import { MultiProductSlider } from '@/scripts/theme/multi-product-slider'
import { WaitlistForm } from '@/scripts/theme/waitlist-form'
import { KlaviyoForm } from '@/scripts/theme/klaviyo-form'
import { WelcomePopup } from '@/scripts/theme/welcome-popup'
import { FloatingNav } from '@/scripts/theme/floating-nav'
import { MenuShowcase } from '@/scripts/theme/menu-showcase'
import { FeatureShowcase } from '@/scripts/theme/feature-showcase'
import { NumberedShowcase } from '@/scripts/theme/numbered-showcase'
import { LocationList } from '@/scripts/theme/location-list'
import { LocationMapModal } from '@/scripts/theme/location-map-modal'
import { FloatingMapTab } from '@/scripts/theme/floating-map-tab'
import { UcoastFaqItem } from '@/scripts/theme/faq-item'
import { UcoastFaqBot } from '@/scripts/theme/faq-bot'
import { HeroSlideshow } from '@/scripts/theme/hero-slideshow'
q.safeDefineElement(UcoastVideo)
q.safeDefineElement(DeferredMedia)
q.safeDefineElement(SliderComponent)
q.safeDefineElement(SlideshowComponent)
q.safeDefineElement(StickyHeader)
q.safeDefineElement(DetailsDisclosure)
q.safeDefineElement(ProductSlider)
q.safeDefineElement(MultiProductSlider)
q.safeDefineElement(KlaviyoForm)
q.safeDefineElement(WelcomePopup)
q.safeDefineElement(WaitlistForm)
q.safeDefineElement(FloatingNav)
q.safeDefineElement(MenuShowcase)
q.safeDefineElement(FeatureShowcase)
q.safeDefineElement(NumberedShowcase)
q.safeDefineElement(LocationMapModal)
q.safeDefineElement(LocationList)
q.safeDefineElement(FloatingMapTab)
q.safeDefineElement(UcoastFaqItem)
q.safeDefineElement(UcoastFaqBot)
q.safeDefineElement(HeroSlideshow)
